export default __webpack_public_path__ + "static/media/Cuor-di-Crema.206211c5.png";